import React, { Component } from 'react';
import { Icon, Step } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

class QuestionnaireSteps extends Component {

    getActive = (step) => {
        if (this.props.stage === step) {
            return true;
        }
    }

    getCompleted = (step) => {
        if (this.props.stage > step) {
            return true;
        }
    }

    render() {
        const { t } = this.props;
        return <Step.Group vertical size='tiny'>
            <Step active={false} completed={false}>
                <Icon name='user circle outline' />
                <Step.Content>
                    <Step.Title>{this.props.patientName}</Step.Title>
                </Step.Content>
            </Step>
            <Step active={this.getActive(1)} completed={this.getCompleted(1)}>
                <Icon name='info' />
                <Step.Content>
                    <Step.Title>{t("Background")}</Step.Title>
                    <Step.Description>{t("Background Info")}</Step.Description>
                </Step.Content>
            </Step>
            <Step active={this.getActive(2)} completed={this.getCompleted(2)}>
                <Icon name='clipboard list' />
                <Step.Content>
                    <Step.Title>{t("Questionnaire")}</Step.Title>
                    <Step.Description>{t("Citizen Questionnaire")}</Step.Description>
                </Step.Content>
            </Step>
            <Step active={this.getActive(3)} completed={this.getCompleted(3)}>
                <Icon name='list layout' />
                <Step.Content>
                    <Step.Title>{t("Suggestions Title")}</Step.Title>
                    <Step.Description>{t("Suggestions Description")}</Step.Description>
                </Step.Content>
            </Step>
        </Step.Group>;
    }
}

export default withTranslation()(QuestionnaireSteps);
